export default __webpack_public_path__ + "static/media/keuangan.3d7ff460.png";